var antPrefixCls = '.ant-select';
var selectItemCls = '.ant-select-item';
var genDropdownStyle = function genDropdownStyle(token) {
  var _disabled, _option, _ref, _ref2;
  return [(_ref2 = {}, _ref2[antPrefixCls + "-dropdown"] = (_ref = {
    // ========================== Popup ==========================

    padding: token.selectDropdownPadding + "px 0",
    '.ant-select-item': {
      borderRadius: 0,
      paddingTop: 8,
      paddingBottom: 8,
      // =========== Option ===========
      '&-option': (_option = {
        color: token.colorText,
        borderRadius: 0,
        '&:last-child': {
          marginBottom: 0
        }
      }, _option["&-content"] = {
        textAlign: 'left'
      }, _option["&:hover:not(&-disabled)"] = {
        backgroundColor: token.colorInfoBgHover,
        color: token.colorText
        // fontWeight: token.fontWeightMedium,
      }, _option['&-disabled'] = (_disabled = {}, _disabled["&" + selectItemCls + "-option-selected"] = {
        backgroundColor: token.colorBgContainerDisabled
      }, _disabled.color = token.colorTextDisabled, _disabled), _option)
    },
    '.ant-select-item-group,.ant-select-item-option-content': {
      textAlign: 'left'
    },
    '.ant-select-item-group': {
      fontSize: token.fontSize,
      color: token.colorText,
      fontWeight: 600
    }
  }, _ref['&-empty'] = {
    color: token.colorTextDisabled
  }, _ref[selectItemCls + "-empty"] = {
    color: token.colorTextDisabled
  }, _ref), _ref2)];
};

export { genDropdownStyle as default };
